import type JCE from '@chesscom/js-chess-engine';

type Node = JCE.Node.Model | JCE.Position.Starting;

/**
 * Get the line diff between two nodes.
 */
export function getLineDiff(before: Node, after: Node): number {
  return after.ids.line - before.ids.line;
}
